import React from 'react';
import { trackButtonClick } from '../utils/pixel';
export const UrgencyBar = () => {
  return <div className="sticky top-0 z-50 w-full bg-terracotta text-white py-3 px-4 shadow-md" data-id="element-409">
      <div className="max-w-[1200px] mx-auto flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-center" data-id="element-410">
        <p className="font-poppins text-sm sm:text-base font-medium" data-id="element-411">
          <span className="font-bold" data-id="element-412">⏰ PRECIO DE LANZAMIENTO</span> — Solo por
          esta semana. Después sube $10.000 ARS. No vuelve.
        </p>
        <a href="#pricing" onClick={() => trackButtonClick('Quiero el precio')} className="bg-white text-terracotta px-5 py-2 rounded-xl font-poppins font-bold text-sm hover:bg-cream transition-colors whitespace-nowrap shadow-sm" data-id="element-413">
          Quiero el precio
        </a>
      </div>
    </div>;
};